<template>
  <div>
    <v-row align="center" class="pa-4 mb-2 pt-0">
      <v-menu bottom offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="$checkPermission('update_car_number_barrier') && roleName !== 'checkpoint-admin'"
            icon
            class="ml-2"
            v-bind="attrs"
            v-on="on"
          >
            <v-icon>mdi-format-list-bulleted</v-icon>
          </v-btn>
        </template>
        <v-list width="300" dense>
          <v-list-item
            @click.prevent="popupExport = true"
          >
            <v-list-item-title>Загрузить номера ИЗ устройства</v-list-item-title>
          </v-list-item>
          <v-list-item
            @click.prevent="popupImport = true"
          >
            <v-list-item-title>Загрузить номера В устройство</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <!-- Модальное окно для экспорта данных из устройства -->
      <v-dialog v-model="popupExport" max-width="500" content-class="dialog-border-radius">
        <v-card>
          <v-card-title>Загрузка номеров из устройства</v-card-title>
          <v-card-text>
            Эта операция загрузит номера из устройства в базу данных ЛК домофонии.
            Устройство автоматически обрабатывает возможные дубли, поэтому
            дополнительных действий с вашей стороны не требуется.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="popupExport = false">Отмена</v-btn>
            <v-btn color="primary" @click="handleExport()">Подтвердить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Модальное окно для импорта данных в устройство -->
      <v-dialog v-model="popupImport" max-width="500" content-class="dialog-border-radius">
        <v-card>
          <v-card-title>Загрузка номеров в устройство</v-card-title>
          <v-card-text>
            Внимание! Это действие удалит все текущие записи на устройстве и загрузит номера из базы данных.
            Убедитесь, что это действительно необходимо.
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="popupImport = false">Отмена</v-btn>
            <v-btn color="primary" @click="handleImport()">Подтвердить</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-card-title>Госномера автомобилей для распознавания</v-card-title>
      <div>
        <BaseTextField
          v-model="carSearch"
          type-input="string"
          :is-button="false"
          :allow-only-latin="true"
          label="Номер автомобиля"
        />
      </div>
      <v-spacer></v-spacer>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="green"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="dialogNew = true"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-new-box</v-icon>
          </v-btn>
        </template>
        <span>Создание госномера</span>
      </v-tooltip>
      <v-dialog v-model="dialogNew" max-width="650" content-class="dialog-border-radius">
        <new-car-number-dialog
          :active.sync="dialogNew"
          icon="mdi-car"
          :doorphones="filteredDoorphones"
          message="Новый номер автомобиля"
          :is-res-complex="true"
          @save="createCarNumbersForAllBarriers"
          @close="dialogNew = false"
        />
      </v-dialog>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#4C6C93"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="dialogImport = true"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-application-import</v-icon>
          </v-btn>
        </template>
        <span>Импорт госномеров</span>
      </v-tooltip>
      <v-dialog v-model="dialogImport" max-width="550" content-class="dialog-border-radius">
        <v-card>
          <v-card class="card-header" style="box-shadow: none;">
            <span class="text-h5">Импорт базы госномеров</span>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  text
                  x-large
                  right
                  class="btn__icon pa-0"
                  style="position: absolute; right: 15px; height: 50%"
                  width="18"
                  @click="closePopupDeleteKeys"
                >
                  <v-icon color="white">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Закрыть</span>
            </v-tooltip>
          </v-card>
          <v-card-text class="pa-4">
            <strong class="black--text">
              Этот импорт происходит исключительно в базу данных ЛК домофонии. Данные не отправляются на устройство.
            </strong>
          </v-card-text>
          <v-col cols="11" class="py-0 mt-4">
            <v-file-input
              v-model="importFile"
              accept=".csv"
              outlined
              dense
              flat
              label="Файл с номерами автомобилей"
              :rules="[
                value => !!value || 'Обязательное поле',
              ]"
            ></v-file-input>
          </v-col>
          <v-col cols="12" class="pa-4 pt-0 mt-0">
            <p>Госномера будет добавлен ко всем шлагбаумам в жилом комплексе.</p>
          </v-col>
          <v-card-actions>
            <div class="mx-auto">
              <v-btn
                large
                color="success"
                class="text-none"
                dense
                :disabled="importFile === null"
                @click.prevent="importListCarNumbers()"
              >
                Импортировать
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#4C6C93"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="downloadListCarNumbers"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-arrow-down-bold-box-outline</v-icon>
          </v-btn>
        </template>
        <span>Скачать отчёт</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#B81B1B"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="massRemovalNumbers"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-delete-circle-outline</v-icon>
          </v-btn>
        </template>
        <span>Удалить номера</span>
      </v-tooltip>
      <v-dialog v-model="showDeleteCarsDialog" max-width="400" content-class="dialog-border-radius">
        <baseDeleteModal
          :active.sync="showDeleteCarsDialog"
          @close="showDeleteCarsDialog = false"
          @submit="deleteCarNumberSelect('remove', false)"
          messageTitle="Удалить номера автомобилей?"
          messageText="Подтверждая, вы удалите госномера из базы всех шлагбаумов который привязаны к ЖК.
                Если номера привязаны к абонентам, они будут отвязаны."
        />
      </v-dialog>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="#4C6C93"
            class="border card-footer"
            v-bind="attrs"
            v-on="on"
            @click="updateListCars"
          >
            <v-icon style="font-size: 40px; height: inherit;" color="white">mdi-reload</v-icon>
          </v-btn>
        </template>
        <span>Обновить</span>
      </v-tooltip>
    </v-row>
    <v-row>
      <v-col
        v-if="this.resResidentComplex.barriers && this.resResidentComplex.barriers.length > 0"
        cols="12"
        class="ma-4 mt-0 pt-0"
      >
        <v-chip v-for="barrier in resResidentComplex.barriers" :key="barrier.id" class="mr-2 mb-2">
          id: {{ barrier.id }}, адрес: {{ barrier.address }}
          <span v-if="!barrier.device_id">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  v-bind="attrs"
                  v-on="on"
                  width="18"
                  height="18"
                >
                  <v-icon x-small color="orange">mdi-checkbox-blank-circle</v-icon>
                </v-btn>
              </template>
              <span>Старый шлагбаум</span>
            </v-tooltip>
          </span>
          , {{ getDirectionType(barrier.direction) }}
          (sip статус
          <v-icon x-small :color="barrier.sip_status_color">
          mdi-checkbox-blank-circle
        </v-icon>)
        </v-chip>
      </v-col>
    </v-row>
    <v-data-table
      class="table"
      :headers="headersTable"
      :items="filtered"
      item-key="carId"
      show-select
      v-model="selectedCarNumbers"
      :footer-props="{ showFirstLastPage: true }"
      @input="handleSelectionChange"
    >
      <template v-slot:header.data-table-select>
        <div></div>
      </template>
      <template v-slot:item.barrierInfo="{ item }">
        <router-link class="routerLink" :to="`/barrier/${item.barrierId}`">
        {{ item.barrierAddress }}
        </router-link>
      </template>
      <template v-slot:item.status="{ item }">
        <v-chip
          :color="item.isBlocked ? 'orange lighten-2' : 'green lighten-2'"
          :text-color="item.isBlocked ? 'orange darken-4' : 'green darken-4'"
          outlined
          small
          class="cursor-pointer"
          @click="openBlockDialog(item)"
        >
          {{ item.isBlocked ? 'Заблокирован' : 'Активен' }}
        </v-chip>
      </template>
      <template v-slot:item.guest="{ item }">
        <div v-if="item.guestEntryStart && item.guestEntryEnd">
          {{ ruDateFormat(item.guestEntryStart, true) }} - {{ ruDateFormat(item.guestEntryEnd, true) }}
        </div>
        <div v-else-if="!item.guestEntryStart && item.guestEntryEnd">
          Ошибка - {{ ruDateFormat(item.guestEntryEnd, true) }}
        </div>
        <div v-else-if="item.guestEntryStart && !item.guestEntryEnd">
          {{ ruDateFormat(item.guestEntryStart, true) }} - Ошибка
        </div>
      </template>
      <template v-slot:item.createdAt="{ item }">
        <div v-if="item.createdAt && item.createdAt">
          {{ ruDateFormat(item.createdAt) }}
        </div>
      </template>
      <template v-slot:item.notification="{ item }">
        <div v-if="item.notification === 'on'" style="color: #388E3C">Включены</div>
        <div v-else  style="color: crimson">Выключены</div>
      </template>
      <template v-slot:item.action="{ item }">
        <v-row class="flex-nowrap" justify="center">
          <v-tooltip bottom v-if="item.isBlocked">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                text
                v-bind="attrs"
                v-on="on"
                tile
                small
                class="btn__icon ml-2"
                width="18"
                height="18"
                @click.stop="$set(dialogBlockInfo, item.carId, true)"
              >
                <v-icon size="large">mdi-eye</v-icon>
              </v-btn>
            </template>
            <span>Информация о блокировке</span>
          </v-tooltip>

          <v-dialog v-model="dialogBlockInfo[item.carId]" max-width="400" content-class="dialog-border-radius">
            <v-card>
              <v-card-title>Информация о блокировке</v-card-title>
              <v-card-text>
                <p><strong>Номер:</strong> {{ item.carNumber }}</p>
                <p><strong>Заблокировал:</strong> {{ item.blockedByName || 'Неизвестно' }}</p>
                <p><strong>Дата блокировки:</strong> {{ item.blockedAt ? new Date(item.blockedAt).toLocaleString() : 'Неизвестно' }}</p>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text @click="$set(dialogBlockInfo, item.carId, false)">Закрыть</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <template v-if="$checkPermission('update_car_number_barrier')">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  text
                  v-bind="attrs"
                  v-on="on"
                  tile
                  small
                  class="btn__icon ml-4 mr-1"
                  width="18"
                  height="18"
                  @click.stop="$set(dialogWarning, item.carId, true)"
                >
                  <v-icon size="large">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Удалить</span>
            </v-tooltip>
            <v-dialog v-model="dialogWarning[item.carId]" max-width="400" content-class="dialog-border-radius">
              <baseDeleteModal
                :active.sync="dialogWarning[item.carId]"
                @close="$set(dialogWarning, item.carId, false)"
                @submit="deleteCarNumber('remove', item.carNumber, false)"
                messageTitle="Удалить номер автомобиля?"
                messageText="Подтверждая, вы удалите госномер из базы всех шлагбаумов которые привязаны к ЖК.
                Если номер привязан к абоненту, он будет отвязан."
              />
            </v-dialog>
          </template>
        </v-row>
      </template>
    </v-data-table>

    <v-dialog v-model="resultDialog" max-width="700" content-class="dialog-border-radius">
      <v-card>
        <v-card-title class="headline">
          Результат <span style="color: #388E3C; padding-left: 5px; padding-right: 5px">{{ action }}</span> шлагбаумов
        </v-card-title>
        <v-card-text>
          <v-list>
            <v-list-item v-for="(result, index) in results" :key="index">
              <v-list-item-content>
                <v-list-item-title>id: {{ result.id }}, адрес: {{ result.address }}</v-list-item-title>
                <v-list-item-subtitle :class="result.success ? 'text-success' : 'text-error'">
                  {{ result.success ? 'Успешно' : 'Ошибка.' }}
                  <span v-if="result.message">{{ result.message }}</span>
                  <span style="color: orange" v-if="result.error">{{ result.error }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="green darken-1" text @click="resultDialog = false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="blockDialog" max-width="550" content-class="dialog-border-radius">
      <v-card>
        <v-card-title class="headline">
          {{ selectedItem && selectedItem.isBlocked ? 'Разблокировать автомобильный номер?' : 'Заблокировать автомобильный номер?' }}
        </v-card-title>

        <v-card-text>
          Вы уверены, что хотите
          {{ selectedItem && selectedItem.isBlocked ? 'разблокировать' : 'заблокировать' }}
          гос номер <strong>{{ selectedItem && selectedItem.carNumber }}</strong>?
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="blockDialog = false">Отмена</v-btn>
          <v-btn
            :color="selectedItem && selectedItem.isBlocked ? 'green' : 'orange'"
            text
            @click="toggleBlockStatus"
          >
            {{ selectedItem && selectedItem.isBlocked ? 'Разблокировать' : 'Заблокировать' }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ruDateFormatMixin from '@/mixins/ruDateFormat';
import BaseTextField from '../../BaseTextField';
import baseDeleteModal from '../../BaseDeleteModal';
import NewCarNumberDialog from '../../barrier/DetailBarrier/components/NewCarNumberDialog';

export default {
  name: 'ListAbonentsResComplex',
  mixins: [ruDateFormatMixin],
  components: { NewCarNumberDialog, BaseTextField, baseDeleteModal },
  data () {
    return {
      isCreated: true,
      lastCopiedText: null,
      selectedItem: null,
      filters: {},
      filterAbonents: {},
      responseCars: [],
      action: '',
      resResidentComplex: {},
      results: [],
      telephoneSearch: '',
      resultDialog: false,
      showDeleteCarsDialog: false,
      popupExport: false,
      popupImport: false,
      carSearch: '',
      startDate: '',
      endDate: '',
      importFile: null,
      selectedCarNumbers: [],
      dialogWarning: {},
      dialogNew: false,
      dialogImport: false,
      dialogEdit: {},
      totalAccounts: 0,
      blockDialog: false,
      dialogBlockInfo: {},
      headersTable: [
        { text: 'id', value: 'carId', align: 'center', width: '4%' },
        { text: 'Основной шлагбаум', value: 'barrierInfo', align: 'center', width: '25%' },
        { text: 'Номер авто', value: 'carNumber', sortable: false, align: 'center' },
        { text: 'Уведомления', value: 'notification', sortable: false, align: 'center', width: '10%' },
        { text: 'Промежуток действия номера', value: 'guest', sortable: false, align: 'center', width: '20%' },
        { text: 'Статус', value: 'status', sortable: false, align: 'center', width: '5%' },
        { text: 'Дата и время создания', value: 'createdAt', sortable: false, align: 'center', width: '15%' },
        { text: '', value: 'action', sortable: false, align: 'center', width: '5%' },
      ],
    };
  },
  created () {
    this.getResidentComplex();
  },
  computed: {
    ...mapGetters({
      roleName: 'roleName',
    }),
    filtered () {
      if (this.carSearch) {
        return this.responseCars.filter(item => {
          return item.carNumber !== null &&
            String(item.carNumber).toLowerCase().includes(this.carSearch.toLowerCase());
        });
      } else {
        return this.responseCars;
      }
    },
    filteredDoorphones () {
      if (this.resResidentComplex && this.resResidentComplex.doorphones) {
        return this.resResidentComplex.doorphones.filter(doorphone => doorphone.type === 'M');
      }
      return {};
    },
  },
  methods: {
    ...mapActions({
      getCarNumbers: 'Barriers/getCarNumbers',
      simpleUpdateAbonent: 'Abonents/simpleUpdateAbonent',
      loadAbonents: 'Abonents/loadAbonents',
      updateCarNumber: 'Barriers/updateCarNumber',
      downloadListCarsNumbers: 'Barriers/downloadListCarsNumbers',
      importCarNumbersByCsv: 'Barriers/importCarNumbersByCsv',
      viewComplex: 'ResidentComplex/viewComplex',
    }),
    async downloadListCarNumbers () {
      this.results = [];
      const allBlobs = [];

      for (const barrier of this.resResidentComplex.barriers) {
        if (!barrier.device_id) {
          this.results.push({
            id: barrier.id,
            address: barrier.address,
            success: false,
            error: 'Устройство старого образца.',
          });
          continue;
        }

        try {
          this.action = 'Скачивание отчёта';
          const responseBlob = await this.downloadListCarsNumbers({ id: barrier.id });
          allBlobs.push(responseBlob);
          this.results.push({ id: barrier.id, address: barrier.address, success: true });
        } catch (err) {
          this.results.push({ id: barrier.id, address: barrier.address, success: false });
        }
      }

      const combinedBlob = new Blob(allBlobs, { type: 'application/csv' });

      const downloadLink = document.createElement('a');
      downloadLink.download = 'all-cars-numbers.csv';
      downloadLink.href = URL.createObjectURL(combinedBlob);
      downloadLink.click();
      URL.revokeObjectURL(downloadLink.href);
    },
    handleExport () {
      this.popupExport = false;
      this.action = 'Экспорт';
      this.updateTableNumber('export');
    },
    handleImport () {
      this.popupImport = false;
      this.action = 'Импорт';
      this.updateTableNumber('import');
    },
    openBlockDialog (item) {
      this.selectedItem = { ...item };
      this.blockDialog = true;
    },
    handleSelectionChange () {
      if (this.selectedCarNumbers.length > 5) {
        this.selectedCarNumbers.pop();
        this.$flash_danger('Вы можете выбрать не более 5 элементов.');
      }
    },
    // только в бд ЛК домофонии
    async importListCarNumbers () {
      try {
        this.results = [];
        this.dialogImport = false;
        for (const barrier of this.resResidentComplex.barriers) {
          if (!barrier.device_id) {
            this.results.push({
              id: barrier.id,
              address: barrier.address,
              success: false,
              error: 'Устройство старого образца.',
            });
            continue;
          }
          const id = barrier.id;
          const formData = new FormData();
          formData.append('csv_file', this.importFile);
          this.action = 'Импортирования';
          try {
            const response = await this.importCarNumbersByCsv({
              id: id,
              formData,
              actionShould: 'import_bd',
            });
            if (response.data && response.data.device_error) {
              this.results.push({
                id: id,
                address: barrier.address,
                success: true,
                error: response.data.device_error,
              });
            } else {
              this.results.push({ id: id, address: barrier.address, success: true, message: response.data.message });
            }
          } catch (err) {
            this.results.push({ id: barrier.id, address: barrier.address, success: false, message: err.response.data.message });
          }
        }
        this.resultDialog = true;
        await this.closePopupDeleteKeys();
        await this.getResidentComplex();
      } catch (err) {
        this.$flash_warning('Произошла ошибка при импорте номеров');
      }
    },
    async updateListCars () {
      await this.getResidentComplex()
        .then(() => {
          this.$flash_success('Таблица обновлена!');
        });
    },
    massRemovalNumbers () {
      if (this.selectedCarNumbers.length) {
        this.showDeleteCarsDialog = true;
      } else {
        this.$flash_danger('Выберите номер авто.');
      }
    },
    getDirectionType (item) {
      switch (item) {
        case 1: return 'Въезд/Выезд';
        case 2: return 'Только въезд';
        case 3: return 'Только выезд';
        default: return '';
      }
    },
    async getAbonentData (carNumber) {
      this.filterAbonents.car_number = carNumber;
      this.loadAbonents({
        filters: this.filterAbonents,
      })
        .then(async (data) => {
          if (data.abonents[0]) {
            const dataManagement = {
              car_number: '',
            };
            await this.simpleUpdateAbonent({
              idAbonent: data.abonents[0].id,
              dataAbonent: dataManagement,
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    closePopupDeleteKeys () {
      this.dialogImport = false;
      this.importFile = null;
    },
    toggleBlockStatus () {
      this.action = 'Изменение статуса гос номера';
      this.blockDialog = false;
      const actionShould = this.selectedItem.isBlocked ? 'unblock' : 'block';
      this.updateTableNumber(actionShould, this.selectedItem.carNumber);
    },
    async createCarNumbersForAllBarriers (actionShould, carNumber, notification, date) {
      this.action = 'Создания госномеров';
      await this.updateTableNumber(actionShould, carNumber, notification, date);
    },
    async deleteCarNumber (actionShould, carNumber, notification) {
      await this.getAbonentData(carNumber);
      this.action = 'Удаление госномера';
      const date = [];
      await this.updateTableNumber(actionShould, carNumber, notification, date);
    },
    async deleteCarNumberSelect (actionShould, notification) {
      const data = this.selectedCarNumbers.map(item => item.carNumber);

      for (const carNumber of data) {
        await this.getAbonentData(carNumber);

        this.action = 'Удаление госномера';
        const date = [];
        await this.updateTableNumber(actionShould, carNumber, notification, date);
      }
      this.selectedCarNumbers = [];
    },
    async updateTableNumber (actionShould, carNumber, notification, date) {
      this.results = [];
      for (const barrier of this.resResidentComplex.barriers) {
        if (!barrier.device_id) {
          this.results.push({
            id: barrier.id,
            address: barrier.address,
            success: false,
            error: 'Устройство старого образца.',
          });
          continue;
        }
        const barrierId = barrier.id;
        try {
          const dataCar = {
            action_should: actionShould,
          };
          if (carNumber) {
            dataCar.car_number = carNumber;
          }
          if (notification) {
            dataCar.notify = notification ? 'on' : 'off';
          }
          if (date && date.length) {
            dataCar.start_date = date[0];
            dataCar.end_date = date[1];
          }
          const response = await this.updateCarNumber({
            id: barrierId,
            data: dataCar,
          });
          if (response.data && response.data.invalid_entries) {
            // Обрабатываем невалидные записи когда делаем импорт
            response.data.invalid_entries.forEach(invalidEntry => {
              this.results.push({
                id: barrierId,
                address: barrier.address,
                success: false,
                error: `Номер ${invalidEntry.car_number}: ${invalidEntry.error}`,
              });
            });
          }
          if (response.data && response.data.device_error) {
            this.results.push({
              id: barrierId,
              address: barrier.address,
              success: true,
              error: response.data.device_error,
            });
          } else {
            this.results.push({ id: barrierId, address: barrier.address, success: true, message: response.data.message });
          }
        } catch (err) {
          if (err.message.includes('422')) {
            const response = err.response.data;
            for (const input in response) {
              response[input].forEach(error => this.$flash_warning(input + ': ' + error));
            }
          }
          this.results.push({ id: barrierId, address: barrier.address, success: false, message: err.response.data.message });
        }
      }
      await this.getResidentComplex();
      this.resultDialog = true;
    },
    async getResidentComplex () {
      this.viewComplex(this.$route.params.id)
        .then(async (res) => {
          this.resResidentComplex = res;
          this.responseCars = res.barriers.flatMap(barrier =>
            barrier.car_numbers.map(car => ({
              barrierId: barrier.id,
              barrierAddress: barrier.address,
              carId: car.id,
              carNumber: car.car_number,
              isBlocked: car.is_blocked,
              blockedBy: car.blocked_by,
              blockedByName: car.blocked_by_name,
              blockedAt: car.blocked_at,
              guestEntryStart: car.guest_entry_start,
              guestEntryEnd: car.guest_entry_end,
              notification: car.notification,
              createdAt: car.created_at,
            })),
          );
        })
        .catch((e) => {
          console.error(e);
          this.$flash_warning('Ошибка при загрузке жилого комплекса');
        });
    },
  },
};
</script>

<style lang="scss" scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
.table-custom-header {
  padding: 5px !important;
  font-size: 13px !important;
  max-width: 2%;
  text-overflow: ellipsis;
}
.table-custom-header.wrap-text span {
  white-space: normal;
}
.table-custom-header span {
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}
.border {
  border-radius: 16px;
}
.card-footer {
  background-color: #4C6C93;
  color: white;
  width: 65px !important;
  margin-right: 15px;
  height: 65px !important;
  padding: 5px 16px;
}
.routerLink {
  background: none;
  border: none;
  color: blue;
  text-decoration: none;
  cursor: pointer;
  padding: 0;
  font-size: inherit;
  font-weight: inherit;
}

.routerLink:hover {
  color: darkblue;
  text-decoration: underline;
}

.v-application a {
  color: #434850;
}
.v-application p {
  margin-bottom: 0;
}

.card-header {
  border-radius: 16px;
  text-align: center;
  height: 50px;
  padding-top: 10px;
  background-color: rgba(224, 179, 137, 0.5);
}
@media screen and (max-width: 800px) {
  .card-header {
    margin-bottom: 30px;
  }
}
</style>
